import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import gamaLogo from '../../Assets/images/gamamobility-logo_vert-b.png';
import './header.css';

import { useFormContext } from '../../Context/DeclarationContext';
import { HOME_ROUTE } from '../Router/constant';

export const HeaderComponent = () => {
  const { state } = useFormContext();
  return (
    <div className="header">
      <Row className="logo">
        <Col sm={24} xs={24}>
          <img src={gamaLogo} alt="Gama Mobility" style={{ width: 130, height: "auto" }} />
        </Col>
      </Row>

      <Row>
        <Col sm={18} xs={24} className="header_title">
          <div>
            <Link to={HOME_ROUTE}>Portal de Seguros y Siniestros</Link>
            {state.headerTitle && <span className="post_title"> / {state.headerTitle}</span>}
          </div>
        </Col>
      </Row>
    </div>
  );
};
